import React from 'react';
import BrandedMissionName from '../common/BrandedMissionName';
import homeAboutVideo from '../../assets/Drishtikon Video final 1.mov';

const HomeAbout = () => {
  return (
    <section id="home-about" className="bg-white px-6 py-14 md:px-12">
      <div className="mx-auto grid max-w-6xl items-center gap-12 md:grid-cols-2 md:gap-16">
        <div className="order-2 md:order-1 md:pr-2 lg:pr-4">
          <h2 className="mb-4 text-center text-3xl font-bold text-accent md:text-left md:text-4xl">
            Welcome to Our Mission
          </h2>
          <div className="mb-7 space-y-4 text-base leading-relaxed text-gray-600 md:text-lg">
            <p>
              They are all around us. The underprivileged women/ the women
              belonging to low income group/ the women belonging to the lower
              strata of society, the hardworking domestic help, the dedicated
              Attendant, the tirelessly working housewife,the cleaner and more
              such women. And most of us know that most of them are living very
              tough lives.
            </p>
            <p>
              Yet, they deal with their struggles with undaunted courage.
              We always wanted to acknowledge them for their courage but
              didn&apos;t know how.
            </p>
            <p>
              <BrandedMissionName /> is the platform which recognizes
              the courage of these unsung heroines , by honoring them with a
              monetary reward and a prize cup. A gesture which may not remove all
              their problems, but surely motivate and boost their courage to
              handle their problems. Let us all join hands and participate in
              this movement, <BrandedMissionName />
            </p>
          </div>
        </div>
        <div className="order-1 flex justify-center md:order-2 md:pl-2 lg:pl-4">
          <div className="w-full max-w-[280px] sm:max-w-[300px] md:max-w-[320px] overflow-hidden rounded-3xl bg-black shadow-xl ring-1 ring-black/5">
            <div className="relative aspect-[9/16] w-full">
              <video
                src={homeAboutVideo}
                className="absolute inset-0 h-full w-full object-cover"
                controls
                playsInline
                preload="metadata"
                loop
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeAbout;
